import script from "./RectifyReportList.vue?vue&type=script&setup=true&lang=js"
export * from "./RectifyReportList.vue?vue&type=script&setup=true&lang=js"

import "./RectifyReportList.vue?vue&type=style&index=0&id=007ae40a&lang=scss"

const __exports__ = script;

export default __exports__